<main class="unauthorized-page">
  <section class="unauthorized-card" aria-labelledby="unauthorized-title">
    <div class="unauthorized-brand-row">
      <div class="unauthorized-atb-brand" aria-label="ATB Assurant Trade Bridge">
        <app-logo />
      </div>
      <div class="unauthorized-assurant" aria-label="Assurant">
        <img
          src="/assets/branding/Assurant_Logo.png"
          alt="Assurant"
        />
      </div>
    </div>
    <div class="unauthorized-icon" aria-hidden="true">
      <span class="unauthorized-shield">!</span>
    </div>
    <div class="unauthorized-code">401</div>
    <h1 id="unauthorized-title">Access Denied</h1>
    <p>You don't have permission to access this page.</p>
    <button type="button" class="unauthorized-back-button" (click)="goBack()">
      <span aria-hidden="true">&#8592;</span>
      Go Back
    </button>
  </section>
</main>
